import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        placeholders: [],
        isLoadingSmsTemplatePlaceholders: false
    },
    getters: {
        getField, //vuex-map-fields
    },
    mutations: {
        updateField, //vuex-map-fields
    },
    actions: {
        async get({ commit, state, dispatch }, payload){
            updateField(state, { path: "isLoadingSmsTemplatePlaceholders", value: true });
            return axios
                .get(this._vm.$apiURL + "/sms-templates-placeholders")
                .then((response) => {
                    updateField(state, { path: "placeholders", value: response.data.data });
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                })
                .finally(() => {
                    updateField(state, { path: "isLoadingSmsTemplatePlaceholders", value: false });
                });
        }
    },
}
